import { render, staticRenderFns } from "./DiscountStock.vue?vue&type=template&id=a621b8ee&"
import script from "./DiscountStock.vue?vue&type=script&lang=js&"
export * from "./DiscountStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports